"use client";

import { Button } from "@dc/ui/components";
import { useRollbar } from "@rollbar/react";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function ResolveError({
  error,
  reset,
}: {
  error: globalThis.Error & { digest?: string };
  reset: () => void;
}) {
  const rollbar = useRollbar();
  const t = useTranslations("errors");

  useEffect(() => {
    console.error("Resolve error:", error);
    rollbar.error(error, { errorDigest: error.digest });
  }, [error, rollbar]);

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center space-y-4">
      <div className="rounded-md border border-danger-200 bg-danger-50 p-6 text-center">
        <h2 className="mb-2 font-semibold text-danger text-lg">{t("resolve.title")}</h2>
        <p className="mb-4 text-danger-600 text-sm">{t("resolve.description")}</p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button color="primary" variant="solid" onPress={() => reset()}>
            {t("actions.try_again")}
          </Button>
          <Button color="default" variant="bordered" onPress={() => window.location.reload()}>
            {t("actions.refresh_page")}
          </Button>
        </div>
      </div>
    </div>
  );
}
